import vuetify from '@/plugins/vuetify'
import moment from 'moment'

export default {
  data: () => ({}),
  computed: {
    // read only
    MOBILE_BREAK_POINT() {
      return vuetify.preset.breakpoint.thresholds.xs
    },
  },
  methods: {
    is_empty(_var) {
      if (_var == null) {
        // typeof null -> object : for hack a bug of ECMAScript
        return true
      }
      switch (typeof _var) {
        case 'object':
          if (Array.isArray(_var)) {
            // When object is array:
            return _var.length === 0
          } else {
            // When object is not array:
            if (
              Object.keys(_var).length > 0 ||
              Object.getOwnPropertySymbols(_var).length > 0
            ) {
              return false
            } else if (_var.valueOf().length !== undefined) {
              return _var.valueOf().length === 0
            } else if (typeof _var.valueOf() !== 'object') {
              return this.is_empty(_var.valueOf())
            } else {
              return true
            }
          }
        case 'string':
          return _var === ''
        case 'number':
          return _var == 0
        case 'boolean':
          return !_var
        case 'undefined':
        case 'null':
          return true
        case 'symbol':
          break
        // Since ECMAScript6
        case 'function':
          break
        default:
          return false
      }
    },
    isset(_var) {
      if (_var === null || _var === undefined) {
        return false
      } else {
        return true
      }
    },
    in_array(_var, arr) {
      if (arr.indexOf(_var) >= 0) {
        return true
      } else {
        return false
      }
    },
    // page transition without active-class(visited)
    page_to(link) {
      this.$router.push(link).catch((error) => {
        // Do nothing.
      })
    },
    trimText(text, limit) {
      if (text instanceof Array) {
        let stringText = ''
        for (let i = 0; i < text.length; i++) {
          stringText =
            i == text.length - 1
              ? stringText + text[i]
              : stringText + text[i] + ','
        }
        text = stringText
      }
      return text.length > limit ? text.slice(0, limit) + '…' : text
    },
    isTextColorDark(hexcolor) {
      const r = parseInt(hexcolor.substr(1, 2), 16)
      const g = parseInt(hexcolor.substr(3, 2), 16)
      const b = parseInt(hexcolor.substr(5, 2), 16)
      return (r * 299 + g * 587 + b * 114) / 1000 < 128 ? false : true
    },
    ucfirst(text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    sortByTitle(array, isAsc) {
      return array.sort(function(a, b) {
        if (a.title.value.toLowerCase() < b.title.value.toLowerCase()) {
          return isAsc ? -1 : 1
        }
        if (a.title.value.toLowerCase() > b.title.value.toLowerCase()) {
          return isAsc ? 1 : -1
        }
        return 0
      })
    },
    sortByTitleString(array, isAsc) {
      return array.sort(function(a, b) {
        if (a.title.toLowerCase() < b.title.toLowerCase()) {
          return isAsc ? -1 : 1
        }
        if (a.title.toLowerCase() > b.title.toLowerCase()) {
          return isAsc ? 1 : -1
        }
        return 0
      })
    },
    sortByCreatedAt(array, isAsc) {
      return array.sort(function(a, b) {
        if (a.created_at_origin < b.created_at_origin) return isAsc ? -1 : 1
        if (a.created_at_origin > b.created_at_origin) return isAsc ? 1 : -1
        return 0
      })
    },
    getCommonErrorMessage(
      error,
      message = 'An unexpected error has occurred. Please reload the window.'
    ) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.description
      ) {
        return error.response.data.description
      } else {
        return message
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () =>
          resolve(reader.result.substr(reader.result.indexOf(',') + 1))
        reader.onerror = (error) => reject(error)
      })
    },
    async setLabelsForBrain(items) {
      const cacheCellLabels = {}
      const cacheExperimentLabels = {}
      for (const item of items) {
        const cellLabels = []
        const dispCellLabels = []
        const experimentLabels = []
        const dispExperimentLabels = []
        for (const cellLabel of item['CellLabels']) {
          const label = null
          if (cacheCellLabels[cellLabel]) {
            label = cacheCellLabels[cellLabel]
          } else {
            label = await this.getMyTagsById('marker', cellLabel)
            cacheCellLabels[cellLabel] = label
          }
          if (!label) {
            continue
          }
          cellLabels.push(label)
          dispCellLabels.push(label.ItemId)
        }
        for (const experimentLabel of item['ExperimentLabels']) {
          const label = null
          if (cacheExperimentLabels[experimentLabel]) {
            label = cacheExperimentLabels[experimentLabel]
          } else {
            label = await this.getMyTagsById('experiment', experimentLabel)
            cacheExperimentLabels[experimentLabel] = label
          }
          if (!label) {
            continue
          }
          experimentLabels.push(label)
          dispExperimentLabels.push(label.ItemId)
        }
        item['CellLabels'] = cellLabels
        item['DispCellLabels'] = dispCellLabels
        item['ExperimentLabels'] = experimentLabels
        item['DispExperimentLabels'] = dispExperimentLabels
      }
    },
    convertBrainObjectForDisplay(item) {
      let statusText
      switch (item.PreprocessingStatus) {
        case 'preparing':
        case 'running':
          statusText = 'Processing'
          break
        case 'complete':
          statusText = 'OK'
          break
        case 'failed':
          statusText = 'Failed'
          break
        default:
          statusText = ''
      }
      return {
        id: item.ItemId,
        title: {
          value: item.Title,
          dispValue: item.Title,
          editable: false,
          updatable: true,
          loading: false,
          rules: [
            (v) => !!v || 'Required.',
            (v) => !v || /^[ -~]*$/i.test(v) || 'Invalid characters.',
            (v) =>
              !v || v.length <= 128 || 'Please enter within 128 characters.',
          ],
        },
        created_at_origin: item.CreatedAt,
        created_at: moment(item.CreatedAt).format('YYYY/MM/DD'),
        updated_at: moment(item.UpdatedAt).format('YYYY/MM/DD'),
        thumbnail: null,
        loaded: false,
        loading: false,
        preprocessingStatus: item.PreprocessingStatus,
        statusText: statusText,
        shared: item.Shared,
        cellLabels: {
          value: item.CellLabels,
          dispValue: item.DispCellLabels,
          editable: false,
          updatable: true,
          loading: false,
        },
        experimentLabels: {
          value: item.ExperimentLabels,
          dispValue: item.DispExperimentLabels,
          editable: false,
          updatable: true,
          loading: false,
        },
        age: {
          value: null,
          dispValue: null,
          period: '',
          dispPeriod: null,
          periods: {
            months: 30,
            weeks: 7,
            days: 1,
          },
          editable: false,
          updatable: true,
          loading: false,
          rules: [
            (v) => !v || /^[0-9]*$/i.test(v) || 'Only numbers can be used.',
          ],
        },
        strain: {
          value: null,
          dispValue: null,
          editable: false,
          updatable: true,
          loading: false,
        },
        notes: {
          value: null,
          editable: false,
          updatable: true,
          loading: false,
          rules: [
            (v) => !v || /^[ -~\n\r]*$/i.test(v) || 'Invalid characters.',
            (v) =>
              !v || v.length <= 2048 || 'Please enter within 2048 characters.',
          ],
        },
        owner: {
          id: item.OwnerId,
          info: null,
          loaded: false,
          loading: false,
        },
        publicAccess: item.PublicAccess,
        selected: false,
      }
    },
    async getDetailOfBrainNotAvailable(brainIdNotAvailable) {
      try {
        const result = await this.getBrainById(brainIdNotAvailable)
        if (result) {
          // Made unshared, but public brain.
          return 'Brain id: ' + brainIdNotAvailable + ' is unshared.'
        }
      } catch (error) {
        if (error.response.data.Message.includes('this item is archived')) {
          return 'Brain id: ' + brainIdNotAvailable + ' is archived.'
        } else if (
          error.response.data.Message.includes('item ownership error')
        ) {
          return 'Brain id: ' + brainIdNotAvailable + ' is unshared.'
        } else {
          return 'Brain id: ' + brainIdNotAvailable + " doesn't exist."
        }
      }
    },
  },
}
